module.exports = __webpack_public_path__ + "44a35a4d5ebd13289ebfb7275af24b81.png";